import { Component, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { AppState } from './store/app.states';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { GetJourneyStepsRequestAction } from './store/common/common.actions';
import { commonState_LatestJourney } from './store/common/common.selectors';
import { ComponentBase } from './views/component-base';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet],
})
export class AppComponent extends ComponentBase implements OnInit {
  title = 'Member Join';

  journeySteps$ = this.store.pipe(select(commonState_LatestJourney));

  constructor(
    public store: Store<AppState>,
    public translate: TranslateService,
  ) {
    translate.addLangs(['en']);
    translate.setDefaultLang('en');
    super();
  }

  ngOnInit(): void {
    super.ngOnInitBase();

    this.sub = this.journeySteps$.subscribe(x => {
      if (!x) {
        this.store.dispatch(GetJourneyStepsRequestAction());
      }
    })
  }

}
